export default __webpack_public_path__ + "static/media/setion04_kv02_m.7b80ee9e.png";